import React from 'react';

const Alert = ({ type, title, message, onClose, className = '', ...props }) => {
  const getIcon = (type) => {
    switch (type) {
      case 'success':
        return '✅';
      case 'warning':
        return '⚠️';
      case 'error':
        return '❌';
      case 'info':
        return 'ℹ️';
      default:
        return 'ℹ️';
    }
  };

  const getTypeClass = (type) => {
    switch (type) {
      case 'success':
        return 'alert-success';
      case 'warning':
        return 'alert-warning';
      case 'error':
        return 'alert-error';
      case 'info':
        return 'alert-info';
      default:
        return 'alert-info';
    }
  };

  return (
    <div className={`alert-modern ${getTypeClass(type)} ${className}`} {...props}>
      <div className="alert-icon">{getIcon(type)}</div>
      <div className="alert-content">
        {title && <div className="alert-title">{title}</div>}
        <div className="alert-message">{message}</div>
      </div>
      {onClose && (
        <button 
          onClick={onClose}
          className="alert-close-btn"
          style={{ 
            background: 'none', 
            border: 'none', 
            cursor: 'pointer',
            color: 'currentColor',
            opacity: 0.7,
            fontSize: '18px',
            padding: '0 4px'
          }}
          aria-label="Close alert"
        >
          ×
        </button>
      )}
    </div>
  );
};

export default Alert;